import { Component, HostListener, input, output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

/**
 * Modal confirmation dialog (shadcn AlertDialog look). The body is projected, so callers keep
 * their own copy; `confirm` / `cancel` fire on the buttons, the backdrop and Escape.
 */
@Component({
  selector: 'app-confirm-dialog',
  imports: [IconComponent],
  template: `
    @if (open()) {
      <div class="backdrop" (click)="cancel.emit()">
        <div
          class="card dialog"
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="confirm-dialog-title"
          (click)="$event.stopPropagation()"
        >
          <div class="flex items-start justify-between gap-3">
            <h2 id="confirm-dialog-title" class="m-0 text-lg font-semibold">{{ title() }}</h2>
            <button
              type="button"
              class="btn btn-ghost btn-icon btn-sm"
              aria-label="Close"
              (click)="cancel.emit()"
            >
              <app-icon name="x" />
            </button>
          </div>
          <div class="mt-2 text-sm leading-relaxed text-muted-foreground">
            <ng-content />
          </div>
          <div class="mt-6 flex justify-end gap-2">
            <button type="button" class="btn btn-ghost" (click)="cancel.emit()">Cancel</button>
            <button
              type="button"
              class="btn"
              [class.btn-primary]="!destructive()"
              [class.btn-destructive]="destructive()"
              [disabled]="busy()"
              (click)="confirm.emit()"
            >
              {{ confirmLabel() }}
            </button>
          </div>
        </div>
      </div>
    }
  `,
})
export class ConfirmDialogComponent {
  readonly open = input(false);
  readonly title = input.required<string>();
  readonly confirmLabel = input('Confirm');
  readonly destructive = input(false);
  readonly busy = input(false);
  readonly confirm = output<void>();
  readonly cancel = output<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open()) this.cancel.emit();
  }
}
